<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Modifications non appliquées</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <p class="text">Vous avez des modifications non appliquées.</p>
            <p class="text">Voulez-vous appliquer vos changements avant de sélectionner un autre élément ?.</p>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" [mat-dialog-close]="false">Non</button>
        <button mat-raised-button class="accent-button" [mat-dialog-close]="true">Oui</button>
    </mat-card-actions>
</mat-card>
